// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 附件类型枚举 枚举类
 * 附件类型枚举，附件是应用或组件的相关自定义文件
 */
export enum EnumAttachmentType {
  /** SQL脚本文件 : SQL脚本文件 */
  SQLScript = 1
}

/**
 * 附件类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumAttachmentTypeMD {
  private static items = [
    new EnumItemMD('SQLScript', 1, 'SQL脚本文件', 'SQL脚本文件')
  ];

  static getItem(enumItem: EnumAttachmentType) {
    return this.items.find(item => item.name === EnumAttachmentType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
